module.exports = __webpack_public_path__ + "img/ranges.437cc9da.svg";